/* import __COLOCATED_TEMPLATE__ from './filter-wrapper.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();